import { QuotaLimitShow, QuotaLimitCreate, QuotaLimitEdit } from "./quota_limits"

const resource = {
  show: QuotaLimitShow,
  create: QuotaLimitCreate,
  edit: QuotaLimitEdit,
}

export default resource
